import React from "react";

interface Props {
    loading: boolean;
    children: any;
}

const Loading = ({loading, children}: Props) => {
    return (
        <div className="loading-container">
            <div className="content">
                {children}
            </div>
            { loading ? <div className="lds-ring loading-overlay"><div></div><div></div><div></div><div></div></div> : null }
        </div>
    )
}

export default Loading